import React, { useState } from 'react';
import { Card, Form, Button, Alert } from 'react-bootstrap';
import { changepassword } from '../../services/api';
import { toast } from 'react-toastify';
import { useAuth } from '../../contexts/AuthContext';
const Security: React.FC = () => {
  const { user, logout } = useAuth();

  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const [formData, setFormData] = useState({
    current_password: '',
    new_password: '',
    new_password_confirmation: '',
    email: user?.email || '',
    name:user?.name || ''
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSaving(true);
    setError('');

    // validation simple
    if (formData.new_password !== formData.new_password_confirmation) {
      setError('Les mots de passe ne correspondent pas');
      setSaving(false);
      return;
    }

    try {
      await changepassword.update(formData);

      toast.success('Mot de passe changé avec succès');

      setFormData({
        current_password: '',
        new_password: '',
        new_password_confirmation: '',
        email: '',
        name:''
      });

    } catch (err: any) {
      console.error(err);

      if (err.response?.data?.message) {
        setError(err.response.data.message);
      } else {
        setError('Erreur lors du changement de mot de passe');
      }

      toast.error('Erreur');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <h1 className="mb-4">Sécurité</h1>

      <Card>
        <Card.Header>
          <h5>Changer le mot de passe</h5>
        </Card.Header>

        <Card.Body>
          {error && <Alert variant="danger">{error}</Alert>}

          <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
              <Form.Label>Nom complet</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                required
              />
            </Form.Group>
              <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Mot de passe actuel</Form.Label>
              <Form.Control
                type="password"
                name="current_password"
                value={formData.current_password}
                onChange={handleInputChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Nouveau mot de passe</Form.Label>
              <Form.Control
                type="password"
                name="new_password"
                value={formData.new_password}
                onChange={handleInputChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Confirmation</Form.Label>
              <Form.Control
                type="password"
                name="new_password_confirmation"
                value={formData.new_password_confirmation}
                onChange={handleInputChange}
                required
              />
            </Form.Group>

            <div className="d-flex justify-content-end">
              <Button type="submit" disabled={saving}>
                {saving ? 'Changement...' : 'Changer'}
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
};

export default Security;